<template>
  <div>
    <div class="checkin__last-call  checkin__last-call--det mt-4 d-block d-md-flex align-items-center justify-content-between">
      <div class="mb-2 mb-md-0">
        <Icon name="infoCircle" width="20" class="mr-2"/>
        {{message}}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "InfoMediaGeneric",
  props: {
    message: {
      type: String,
      required: true
    }
  },
}
</script>

<style scoped>

</style>